/**
 * @generated SignedSource<<1f742146063c0eef84f5e3e8e6973a3b>>
 * @relayHash 07b96563baf5d018afb7d88ebd41d028
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID de92db525f29aacdea6702bef5f5eaa0758d1c12bf49b6b04be053e62b09848a

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionIssuesSortField = "ASSIGNEE" | "CREATED" | "KEY" | "PRIORITY" | "STATUS" | "TYPE" | "%future added value";
export type JiraVersionIssuesStatusCategories = "DONE" | "IN_PROGRESS" | "TODO" | "%future added value";
export type JiraVersionWarningCategories = "FAILING_BUILD" | "OPEN_PULL_REQUEST" | "OPEN_REVIEW" | "UNREVIEWED_CODE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraMoveIssuesToFixVersionInput = {
  issueIds: ReadonlyArray<string>;
  originalVersionId: string;
  targetVersionId: string;
};
export type JiraVersionIssuesSortInput = {
  order?: SortDirection | null | undefined;
  sortByField?: JiraVersionIssuesSortField | null | undefined;
};
export type JiraVersionIssuesFiltersInput = {
  assigneeAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  epicIds?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
  statusCategories?: ReadonlyArray<JiraVersionIssuesStatusCategories> | null | undefined;
  warningCategories?: ReadonlyArray<JiraVersionWarningCategories> | null | undefined;
};
export type moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation$variables = {
  filters?: JiraVersionIssuesFiltersInput | null | undefined;
  input: JiraMoveIssuesToFixVersionInput;
  isDevopsFeatureDisabledInFedRamp: boolean;
  shouldIncludeDevOpsFieldsViaAgs: boolean;
  sortBy?: JiraVersionIssuesSortInput | null | undefined;
};
export type moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation$data = {
  readonly jira: {
    readonly moveIssuesToFixVersion: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly issuesWithMissingEditPermission: ReadonlyArray<string> | null | undefined;
      readonly issuesWithMissingResolvePermission: ReadonlyArray<string> | null | undefined;
      readonly originalVersion: {
        readonly " $fragmentSpreads": FragmentRefs<"addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion" | "issueTotalCount_softwareReleasesVersionDetailIssueList" | "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion" | "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation = {
  response: moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation$data;
  variables: moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeDevOpsFieldsViaAgs"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "success"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "message"
  }
],
v8 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": (v7/*: any*/)
},
v9 = {
  "kind": "ScalarField",
  "name": "issuesWithMissingResolvePermission"
},
v10 = {
  "kind": "ScalarField",
  "name": "issuesWithMissingEditPermission"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "Literal",
  "name": "filter",
  "value": "ALL"
},
v13 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "key"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "collapsedUis"
},
v18 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v19 = {
  "kind": "ScalarField",
  "name": "status"
},
v20 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v21 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v22 = {
  "kind": "ScalarField",
  "name": "picture"
},
v23 = {
  "kind": "ScalarField",
  "name": "description"
},
v24 = [
  (v12/*: any*/),
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "count"
},
v26 = {
  "kind": "ScalarField",
  "name": "state"
},
v27 = {
  "concreteType": "DevOpsSummarisedBuildState",
  "kind": "LinkedField",
  "name": "buildStates",
  "plural": true,
  "selections": [
    (v26/*: any*/),
    (v25/*: any*/)
  ]
},
v28 = [
  (v25/*: any*/)
],
v29 = {
  "kind": "ScalarField",
  "name": "title"
},
v30 = [
  (v25/*: any*/),
  (v11/*: any*/)
],
v31 = {
  "concreteType": "DevOpsSummarisedDeployments",
  "kind": "LinkedField",
  "name": "summarisedDeployments",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v33 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v35 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraMoveIssuesToFixVersionPayload",
            "kind": "LinkedField",
            "name": "moveIssuesToFixVersion",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "originalVersion",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraMoveIssuesToFixVersionPayload",
            "kind": "LinkedField",
            "name": "moveIssuesToFixVersion",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "originalVersion",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "canEditRelatedWork"
                  },
                  {
                    "alias": "allIssues",
                    "args": [
                      (v12/*: any*/)
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": "issues(filter:\"ALL\")"
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      (v15/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "cloudId"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "maxHierarchyLevel": 1,
                              "minHierarchyLevel": 1
                            }
                          }
                        ],
                        "concreteType": "JiraIssueTypeConnection",
                        "kind": "LinkedField",
                        "name": "issueTypes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/)
                                    ]
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                      }
                    ]
                  },
                  {
                    "alias": "allIssuesRedesignTemp",
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": (v14/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canAddAndRemoveIssues"
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "releaseDate"
                  },
                  (v19/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "versionId"
                  },
                  {
                    "concreteType": "JiraVersionDriverResult",
                    "kind": "LinkedField",
                    "name": "driverData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "driver",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v16/*: any*/),
                          (v22/*: any*/),
                          (v11/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "queryError",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      }
                    ]
                  },
                  (v23/*: any*/),
                  (v16/*: any*/),
                  {
                    "concreteType": "JiraVersionWarningConfig",
                    "kind": "LinkedField",
                    "name": "warningConfig",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "openReview"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                      },
                      (v18/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "JiraVersionConnectAddonIframeData",
                    "kind": "LinkedField",
                    "name": "connectAddonIframeData",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "appKey"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "moduleKey"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "appName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "location"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "options"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canViewDevTools"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "versionIssueTableHiddenColumns"
                  },
                  {
                    "alias": "issuesForList",
                    "args": (v24/*: any*/),
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "jql"
                      },
                      {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v11/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                      "priority",
                                      "summary",
                                      "assignee",
                                      "status",
                                      "issuetype"
                                    ]
                                  }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v20/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategory",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "statusCategoryId"
                                                      },
                                                      (v11/*: any*/)
                                                    ]
                                                  },
                                                  (v11/*: any*/),
                                                  (v16/*: any*/),
                                                  (v23/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraStatusField"
                                          },
                                          (v11/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v22/*: any*/),
                                                  (v16/*: any*/),
                                                  (v11/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraSingleSelectUserPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "text"
                                              }
                                            ],
                                            "type": "JiraSingleLineTextField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                  (v16/*: any*/),
                                                  {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "xsmall"
                                                      }
                                                    ]
                                                  },
                                                  (v11/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraIssueTypeField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraPriority",
                                                "kind": "LinkedField",
                                                "name": "priority",
                                                "plural": false,
                                                "selections": [
                                                  (v16/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "iconUrl"
                                                  },
                                                  (v11/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraPriorityField"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "issueId"
                              },
                              {
                                "concreteType": "DevOpsSummarisedFeatureFlags",
                                "kind": "LinkedField",
                                "name": "summarisedFeatureFlags",
                                "plural": false,
                                "selections": (v14/*: any*/)
                              },
                              (v20/*: any*/),
                              {
                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  {
                                    "concreteType": "DevOpsSummarisedEntities",
                                    "kind": "LinkedField",
                                    "name": "devOpsSummarisedEntities",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "DevOpsSummarisedDeployments",
                                        "kind": "LinkedField",
                                        "name": "summarisedDeployments",
                                        "plural": false,
                                        "selections": [
                                          (v25/*: any*/),
                                          (v11/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "deploymentState"
                                          },
                                          {
                                            "concreteType": "DevOpsEnvironment",
                                            "kind": "LinkedField",
                                            "name": "deploymentEnvironment",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "category"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "DevOpsSummarisedBuilds",
                                        "kind": "LinkedField",
                                        "name": "summarisedBuilds",
                                        "plural": false,
                                        "selections": [
                                          (v25/*: any*/),
                                          (v11/*: any*/),
                                          (v27/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueDevSummary",
                                        "kind": "LinkedField",
                                        "name": "devSummary",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "pullrequest",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssuePullRequestDevSummary",
                                                "kind": "LinkedField",
                                                "name": "overall",
                                                "plural": false,
                                                "selections": [
                                                  (v25/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "branch",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueBranchDevSummary",
                                                "kind": "LinkedField",
                                                "name": "overall",
                                                "plural": false,
                                                "selections": (v28/*: any*/)
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "review",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueReviewDevSummary",
                                                "kind": "LinkedField",
                                                "name": "overall",
                                                "plural": false,
                                                "selections": [
                                                  (v25/*: any*/),
                                                  (v26/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "lastUpdated"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "stateCount"
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueDevSummaryByProvider",
                                                "kind": "LinkedField",
                                                "name": "summaryByProvider",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "providerId"
                                                  },
                                                  (v16/*: any*/),
                                                  (v25/*: any*/)
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "commit",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueCommitDevSummary",
                                                "kind": "LinkedField",
                                                "name": "overall",
                                                "plural": false,
                                                "selections": (v28/*: any*/)
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "build",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueBuildDevSummary",
                                                "kind": "LinkedField",
                                                "name": "overall",
                                                "plural": false,
                                                "selections": [
                                                  (v25/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "failedBuildCount"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "successfulBuildCount"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "unknownBuildCount"
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "deploymentEnvironments",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                "kind": "LinkedField",
                                                "name": "overall",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                    "kind": "LinkedField",
                                                    "name": "topEnvironments",
                                                    "plural": true,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      (v29/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                    "kind": "LinkedField",
                                    "name": "summarisedFeatureFlags",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "mostRelevantDisplayName"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "mostRelevantEnabled"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "mostRelevantRolloutPercentage"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      (v31/*: any*/),
                                      {
                                        "concreteType": "DevOpsSummarisedBuilds",
                                        "kind": "LinkedField",
                                        "name": "summarisedBuilds",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v25/*: any*/),
                                          (v11/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  (v31/*: any*/),
                                  {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": (v30/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          (v32/*: any*/)
                        ]
                      },
                      (v33/*: any*/)
                    ]
                  },
                  {
                    "alias": "issuesForList",
                    "args": (v24/*: any*/),
                    "filters": [
                      "filter",
                      "sortBy",
                      "filters"
                    ],
                    "handle": "connection",
                    "key": "ListVersion_issuesForList",
                    "kind": "LinkedHandle",
                    "name": "issues"
                  },
                  (v17/*: any*/),
                  {
                    "args": (v34/*: any*/),
                    "concreteType": "JiraVersionApproverConnection",
                    "kind": "LinkedField",
                    "name": "approvers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraVersionApproverEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraVersionApprover",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v16/*: any*/),
                                  (v22/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "AtlassianAccountUserExtendedProfile",
                                        "kind": "LinkedField",
                                        "name": "extendedProfile",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "jobTitle"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  (v11/*: any*/),
                                  (v21/*: any*/)
                                ]
                              },
                              (v19/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "declineReason"
                              },
                              (v23/*: any*/),
                              (v35/*: any*/),
                              (v20/*: any*/)
                            ]
                          },
                          (v32/*: any*/)
                        ]
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": "approvers(first:100)"
                  },
                  {
                    "args": (v34/*: any*/),
                    "handle": "connection",
                    "key": "version_approvers",
                    "kind": "LinkedHandle",
                    "name": "approvers"
                  },
                  {
                    "concreteType": "JiraVersionRichTextSection",
                    "kind": "LinkedField",
                    "name": "richTextSection",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "json"
                          }
                        ]
                      },
                      (v29/*: any*/)
                    ]
                  },
                  (v35/*: any*/),
                  {
                    "condition": "isDevopsFeatureDisabledInFedRamp",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "concreteType": "DevOpsSummarisedEntities",
                        "kind": "LinkedField",
                        "name": "devOpsSummarisedEntities",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "DevOpsFeatureFlagProvider",
                                "kind": "LinkedField",
                                "name": "featureFlagProviders",
                                "plural": true,
                                "selections": [
                                  (v20/*: any*/),
                                  (v11/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "createFeatureFlagTemplateUrl"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "connectFeatureFlagTemplateUrl"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "logoUrl"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "de92db525f29aacdea6702bef5f5eaa0758d1c12bf49b6b04be053e62b09848a",
    "metadata": {},
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "99186247cd88cec5255d60a17909165e";

export default node;
